'use client'

import type * as React from 'react'
import { format } from 'date-fns'
import { Calendar as CalendarIcon } from 'lucide-react'
import { parseAsString, useQueryState } from 'nuqs'
import { cn } from '@/lib/utils'

import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'

export function OrdersDatePicker({
  className,
}: React.HTMLAttributes<HTMLDivElement>) {
  const [from, setFrom] = useQueryState('from', parseAsString.withDefault(''))
  const [to, setTo] = useQueryState('to', parseAsString.withDefault(''))

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={'outline'}
            size={'sm'}
            className={cn(
              'justify-start text-left font-normal',
              !from && 'text-muted-foreground',
            )}
          >
            <CalendarIcon className="size-4" />
            {from ? (
              to ? (
                <>
                  {format(from, 'yyyy-MM-dd')} - {format(to, 'yyyy-MM-dd')}
                </>
              ) : (
                format(from, 'yyyy-MM-dd')
              )
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={from ? new Date(from) : undefined}
            selected={{ from: new Date(from), to: new Date(to) }}
            onSelect={(date) => {
              setFrom(format(date?.from ?? new Date(), 'yyyy-MM-dd'))
              setTo(format(date?.to ?? new Date(), 'yyyy-MM-dd'))
            }}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
